import React from 'react';
import { AllHTMLAttributes, FC } from 'react';
import LinkRenderer, { LinkRendererProps } from '../link-renderer';
import clsx from 'clsx';

export type TextLinkProps = Omit<LinkRendererProps, 'children'> &
  AllHTMLAttributes<HTMLAnchorElement>;

const TextLink: FC<TextLinkProps> = ({
  children,
  className,
  href,
  variant,
  weight,
  target = '_blank',
  external = false,
  ...rest
}) => {
  return (
    <LinkRenderer
      weight={weight}
      variant={variant}
      isDisabled={rest.isDisabled}
    >
      {styleProps => (
        <a
          href={href}
          className={clsx(styleProps.className, className)}
          rel={external ? 'noreferrer noopener' : ''}
          target={external ? target : '_self'}
          {...rest}
        >
          {children}
        </a>
      )}
    </LinkRenderer>
  );
};

export default TextLink;
